<template>
    <router-view v-cloak />
    <NotifyBase />
    <modals-container />
</template>
<script>
import NotifyBase from '@/components/dialogs/NotifyBase.vue';
import { watch, inject } from 'vue';
import { useRoute } from 'vue-router';
export default {
    components: { NotifyBase },
    setup() {
        const route = useRoute();
        const $vfm = inject('$vfm');

        // 已測試，會先觸發watch接著onBeforeMount然後onMounted
        // 機制是當route改變，判斷 是否有打開的modal，有的話就全部關閉
        watch(() => route.name, (nV) => {
            if (nV) {
                if ($vfm.dynamicModals.length > 0) {
                    $vfm.hideAll();
                }
            };
        }, { immediate: true, deep: true });
    },
};
</script>

<style lang="scss">
@import "assets/styles/index.scss";
@import "../node_modules/@vueform/multiselect/themes/tailwind.scss";
[v-cloak] {
    display: none;
}
</style>
